<template>
  <div v-if="banners.length > 0" class="banners">

    <div id="carouselExampleIndicators" class="carousel slide custom-carousel  carousel-fade" data-bs-ride="carousel">
      <!-- Indicadores -->
      <div class="carousel-indicators" style="color:#ff9900">
        <button v-for="(banner, index) in banners" :key="'indicator-' + index" type="button"
          :data-bs-target="'#carouselExampleIndicators'" :data-bs-slide-to="index" :class="{ active: index === 0 }"
          :data-bs-interval="getInterval(banner.image)" :aria-current="index === 0 ? 'true' : null"
          :aria-label="'Slide ' + (index + 1)"></button>
      </div>

      <!-- Slides -->
      <div class="carousel-inner">
        <div v-for="(banner, index) in banners" :key="'slide-' + index" class="carousel-item" :data-bs-interval="getInterval(banner.image)"
          :class="{ active: index === 0 }">
          <!-- Imagen del banner -->
          <img :src="`img/banners/${banner.image}`" class="d-block w-100 imgbanner" :alt="banner.description" loading="lazy"/>

          <!-- Contenido adicional (texto, botones, etc.) -->
          <div class="carousel-caption d-none d-md-block">
            <h5>{{ banner.description }}</h5>
            <!-- Condición para tipo NORMAL -->
            <template v-if="banner.tipo === 'NORMAL' && banner.id_linea !== null && banner.id_linea !== ''">
              <router-link :to="{ name: 'ListadoProductosLinea', params: { id: banner.id_linea, linea: banner.linea } }"
                class="youtube-button">
                <i class="fa fa-youtube-square" aria-hidden="true"></i> Acceder
              </router-link>
            </template>

            <!-- Condición para tipo MEDIA -->
            <template v-if="banner.tipo === 'MEDIA' && banner.url !== '' && banner.url !== null">
              <a :href="banner.url" class="youtube-button" target="_blank">
                <i class="fa fa-youtube-square" aria-hidden="true"></i> Ver video contenido
              </a>
            </template>
          </div>
        </div>
      </div>

      <!-- Controles -->
      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

  </div>
</template>

<script>
//import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel';
//import { cacheImage, getCachedImage } from '@/utils/imageCache';
import { cacheImage, getCachedImage } from '../utils/imageCache.js';
export default {
  components: {
  },
  data() {
    return {
      videoUrl: '',
      selectedBanner: 0,
      banners: [],
      settings: {
        itemsToShow: 1,
        snapAlign: 'center',
      },
    };
  },
  methods: {
    getInterval(imagen) {
      // Puedes ajustar la lógica para decidir el intervalo según el índice   .endsWith('.gif') ? 10000 : 1000
      if (imagen.endsWith('.gif') ) {
        return 8000; // Primer slide con intervalo más largo
      } else {
        return 1500; // Último slide con intervalo más largo
      } 
    },
    modalvideobanner(videoUrl) {
      this.videoUrl = videoUrl;
      $('#playModal').modal('show');
    },
    handleModalShow() {
      const iframe = this.$refs.youtubeIframe;
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    },
    handleModalHide() { },
    cerrarModal() {
      $('#playModal').trigger('pause');
      $('#playModal').modal('hide');
    },
    changeBanner(index) {
      this.selectedBanner = index;
    },
    goToBanner(idx) {
      this.selectedBanner = idx;
    },
    goToPreviousBanner() {
      if (this.selectedBanner > 0) {
        this.selectedBanner -= 1;
      } else {
        this.selectedBanner = this.banners.length - 1;
      }
    },
    goToNextBanner() {
      if (this.selectedBanner < this.banners.length - 1) {
        this.selectedBanner += 1;
      } else {
        this.selectedBanner = 0;
      }
    },
    async obtenerBanners() {
      try {
        const response = await axios.get('/api/banners');
        this.banners = response.data;

        for (let banner of this.banners) {
          const cachedImage = await getCachedImage(`img/banners/${banner.image}`);
          if (cachedImage) {
            banner.cachedImage = cachedImage;
          } else {
            await cacheImage(`img/banners/${banner.image}`);
            banner.cachedImage = `img/banners/${banner.image}`;
          }
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    },
  },
  mounted() {
    this.obtenerBanners();
  },
};
</script>

<style scoped>
.banners {
  margin-top: 1%;
  margin-bottom: 2%;
}
.custom-carousel {
  overflow: hidden;
  max-height: 80vh;
  /* La altura será la mitad de la ventana visible */
}

.imgbanner {
  height: 600px;
  object-fit: fill;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  color: #ff9900;
  /* Color de fondo de los iconos */
}

.carousel-indicators button {
  background-color: #ff9900;
  /* Color de fondo para los indicadores */
}

.carousel-indicators .active {
  background-color: #ff6600;
  /* Color de fondo para el indicador activo */
}

.youtube-button {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  text-decoration: none;
  color: #fff;
  background-color: #c4302b;
  border-radius: 4px;
  border: 1px solid #c4302b;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 20px;
  right: 20%;
  /* Cambiado de left a right */
}

.youtube-button:hover {
  background-color: #e52d27;
  border-color: #e52d27;
}

.youtube-icon {
  margin-left: 8px;
  /* Cambiado de margin-right a margin-left */
  vertical-align: middle;
}

.bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 30px;
  background: rgba(6, 40, 60, 0.8);
  color: #FFF;
  overflow: hidden;
  height: 5%;
}

.bottom-bar .title-container {
  float: left;
  font-weight: 100;
  font-size: 14px;
}

.bottom-bar .right {
  float: right;

}


@media (max-width: 768px) {
  .banners {
    margin-top: 12%;
  }
  .custom-carousel {
    overflow: hidden;
    max-height: 50vh;
    /* La altura será la mitad de la ventana visible */
  }

  .imgbanner {
    height: 250px;
    object-fit: fill;
  }

  .youtube-button {
    padding: 10px;
    /* Reducir el espacio alrededor de los botones */
    line-height: 0;
    /* Ocultar el texto */
  }

  .youtube-button i {
    margin-right: 8px;
    /* Espacio entre el icono y el borde del botón */
  }

}
</style>
